import axios from 'axios';
import {
    BASE_URL, SERVICES, LIST_TO_VALUES,
    LIST_SERVICES_DECRYPT,
    PATHS, LIST_SERVICES_NOS
} from '../properties';
import moment from 'moment';
import firebase from 'firebase';
import jQuery from 'jquery';
import Crypto from 'crypto';
import M from 'materialize-css';
import { jsPDF } from "jspdf";
import store from '../redux/store';
import html2canvas from 'html2canvas';

export const BODY_OPERA_FONDO = { "UsuarioServicio": "", "ContraseniaServicio": "", "Token": "", "RefreshToken": "", "IdUsuario": "", "DeviceToken": "", "SistemaOperativo": "", "AppID": "", "ISS": "", "KEY": "", "Contrato": "", "TipoOper": "", "VentaTotal": "0", "Emisora": "", "Serie": "", "Importe": "", "Precio": "", "Titulos": "", "TipoLiq": "", "Titular": "", "Banco": "", "Cuenta": "", "SoftToken": "", "Pais": "", "Estado": "", "Ciudad": "", "Latitud": "", "Longitud": "", "IP": "" };

export function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return re.test(email);
}

export function getMonthString(m) {
    let d = moment().month();
    let month = "";

    if (m >= 0) {
        d = m;
    }
    switch (d) {
        case 0:
            month = 'Enero';
            break;
        case 1:
            month = 'Febrero';
            break;
        case 2:
            month = 'Marzo';
            break;
        case 3:
            month = 'Abril';
            break;
        case 4:
            month = 'Mayo';
            break;
        case 5:
            month = 'Junio';
            break;
        case 6:
            month = 'Julio';
            break;
        case 7:
            month = 'Agosto';
            break;
        case 8:
            month = 'Septiembre';
            break;
        case 9:
            month = 'Octubre';
            break;
        case 10:
            month = 'Noviembre';
            break;
        case 11:
            month = 'Diciembre';
            break;
        default:
            month = "";
            break;
    }
    return month;
}

export function getMonthStringGraphs(m) {
    let d = moment().month();
    let month = "";

    if (m >= 0) {
        d = m;
    }

    switch (d) {
        case 1:
            month = 'Enero';
            break;
        case 2:
            month = 'Febrero';
            break;
        case 3:
            month = 'Marzo';
            break;
        case 4:
            month = 'Abril';
            break;
        case 5:
            month = 'Mayo';
            break;
        case 6:
            month = 'Junio';
            break;
        case 7:
            month = 'Julio';
            break;
        case 8:
            month = 'Agosto';
            break;
        case 9:
            month = 'Septiembre';
            break;
        case 10:
            month = 'Octubre';
            break;
        case 11:
            month = 'Noviembre';
            break;
        case 12:
            month = 'Diciembre';
            break;
        default:
            month = "";
            break;
    }
    return month;
}



export function esBienvenida() {
    let esBienvenida = localStorage.getItem('bienvenida');

    if (!esBienvenida) {
        localStorage.setItem('bienvenida', "true");
        return true;
    }
    return false;
}

export function onlyDigits(value) {
    var re = /^[0-9]*$/;
    return re.test(value);
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function toCamelCase(str) {
    return str.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))).toUpperCase();
}

export function nWithCommas(x) {
    //return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

//navega a la pantalla de sin autorización con el history de react-router (sin recargar la página);
//si aún no hay history registrado se usa location.href como respaldo
export function irSinAutorizacion() {
    let { history } = store.getState().commonsActions || {};

    if (history && typeof history.push === "function") {
        if (history.location && history.location.pathname === PATHS.SIN_AUTORIZACION) {
            return;
        }
        history.push(PATHS.SIN_AUTORIZACION);
    } else {
        window.location.href = `${PATHS.SIN_AUTORIZACION}`;
    }
}

export async function makeCall(service, data, callbackError) {

    let token = false;
    let refreshToken = false;
    let authorization = false;

    if (localStorage.getItem('token')) {
        token = localStorage.getItem('token');
    }


    if (localStorage.getItem('authorization')) {
        authorization = localStorage.getItem('authorization');
    }

    if (token !== authorization) {
        authorization = token;
    }

    if (token && LIST_SERVICES_NOS.indexOf(service.url) > -1) {
        authorization = token;
    }

    if (localStorage.getItem('idToken')) {

        authorization = localStorage.getItem('idToken');

    }


    if (sessionStorage.getItem('hash')) {
        data.hash = sessionStorage.getItem('hash');
    }



    if (localStorage.getItem('refreshToken')) {
        refreshToken = localStorage.getItem('refreshToken');
    }


    if (!data) {
        data = {}
    }


    try {
        let url = service.url;
        let baseURL = BASE_URL;

        if (service.urlOriginal) {
            url = service.urlOriginal;
        }


        if (service.esINFOCEL) {
            baseURL = "";
        } else {

            service.body.AppID = 'com.valmex.valmexcb';
            service.body.SistemaOperativo = navigator.platform;
        }

        if (service.noParams === null || service.noParams === undefined) {
            if (service.method.toUpperCase() === 'GET') {
                let keys = Object.keys(service.body);
                for (let i = 0; i < keys.length; i++) {
                    let op = "&";
                    if (i === 0) {
                        op = "?"
                    }
                    url += `${op}${keys[i]}=${data[keys[i]]}`;
                }
            }
        }

        //Config request se genera de acuedo a la documentación Axios.  https://github.com/axios/axios#axiosrequestconfig
        let configRequest = {
            url,
            method: service.method,
            baseURL,
            data
        }


        if (service.esINFOCEL) {
            configRequest.baseURL = "";
            configRequest.headers = {
                "Access-Control-Allow-Origin": "*"
            }

        }

        if (authorization) {

            configRequest.headers = {
                "authorization": authorization
            }
        }



        if (data.hasOwnProperty('RefreshToken') && refreshToken && refreshToken.trim() !== '') {
            data.RefreshToken = encryptValues(refreshToken);
        }

        if (data.hasOwnProperty('Token') && token && token.trim() !== '') {
            data.Token = encryptValues(token);
        }

        if (service.esINFOCEL) {
            let re = await jQuery.get(url);
            return re;
        } else {

            data["app"] = "web";

            let result = await axios.request(configRequest);
            let toReturn = readObject(result.data, service.url);

            if (toReturn && toReturn.response && toReturn.response.MensajeError === "Cliente sin acceso"
                && service.url !== "seguridad/cerrarSesion"
            ) {

                localStorage.removeItem('dataUser');
                irSinAutorizacion();

            } else {

                if (toReturn.response && toReturn.response.TokenSesion &&
                    toReturn.response.TokenSesion.trim() !== "") {


                    localStorage.setItem('token', decryptValue(toReturn.response.TokenSesion));
                }

                if (toReturn.response && toReturn.response.RefreshTokenSesion &&
                    toReturn.response.RefreshTokenSesion.trim() !== "") {

                    localStorage.setItem('refreshToken', decryptValue(toReturn.response.RefreshTokenSesion));
                }

                if (toReturn.response && toReturn.response.CurrentToken &&
                    toReturn.response.CurrentToken.trim() !== "") {
                    try {

                        localStorage.setItem('token', decryptValue(toReturn.response.CurrentToken));
                    } catch (error) {
                    }

                }else{
                    debugger;
                    console.log(service.url);
                }


                if (toReturn.response && toReturn.response.firebase &&
                    toReturn.response.firebase.idToken) {

                    try {

                        localStorage.setItem('idToken', decryptValue(toReturn.response.firebase.idToken));
                    } catch (error) {
                    }
                }


                return toReturn;
            }



        }



    } catch (error) {

        if (error && error.response
        ) {

            if (error.response.hasOwnProperty('data') &&
                (error.response.data.msg === "Sin autorización"
                    || error.response.data.msg === "La petición no tiene la cabezera de autenticación")
            ) {
                //si falla el propio cierre de sesión no se vuelve a redirigir para evitar un ciclo
                if (service.url !== SERVICES.TERMINA_SESION.url) {

                    if (callbackError) {
                        callbackError(error);
                    }

                    //la pantalla SinAutorizacion se encarga de cerrar la sesión (deleteSesion)
                    irSinAutorizacion();
                }

                return false;
            } else if (error.response.hasOwnProperty('data') && error.response.status === 403 &&
                (error.response.data.codigo === "GEO_ZONA_RESTRINGIDA" || error.response.data.codigo === "GEO_UBICACION_NO_CONFIABLE")
            ) {
                return { response: error.response.data };
            } else {
                if (callbackError) {
                    callbackError(error);
                } else {
                    throw error;
                }
            }

        } else {
            if (callbackError) {
                callbackError(error);
            } else {
                throw error;
            }
        }
    }




}


export const REGEXS_NEW_PASS = [
    {
        text: "Debe tener entre 10 y 12 caracteres.",
        validator: (value) => {
            if (value.length >= 10 && value.length <= 12) {
                return true;
            }

            return false;
        },
        isCorrect: false
    },
    {
        text: "Debe contener minimo 1 mayúscula, 1 minúscula, 1 número y 1 caracter especial (|!#$%&/()=?¡¿+*{[}]-_.:,;)",
        validator: (value) => {
            let re = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[|!#$%&/()=?¡¿+*{[}\]\-_.:,;])[A-Za-z\d|!#$%&/()=?¡¿+*{[}\]\-_.:,;]{10,12}$/;
            ///^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])(?=\w*[|!#$%&/()=?¡¿+*{[}\]\-_.:,;])\S{10,12}$/;
            return re.test(value);
        },
        isCorrect: false
    },
    {
        text: "No debe incluir el identificador del usuario",
        validator: (value, email = '') => {
            if (!email) return true;
            const prefix = email.split('@')[0];
            if (!prefix) return true;
            return !value.toLowerCase().includes(prefix.toLowerCase());
        },
        isCorrect: false
    },
    {
        text: "No debe incluir el nombre de la casa de bolsa (VALMEX, VALORES, MEXICANOS)",
        validator: (value) => {
            let names = ['VALMEX', 'VALORES', 'MEXICANOS'];
            let include = true;
            names.forEach((v, i) => {
                if (value.toUpperCase().includes(v)) {
                    include = false;
                }
            });

            return include;
        },
        isCorrect: false
    },
    {
        text: "No debe contener más de dos caracteres consecutivos iguales (p.e. 222, eee)",
        validator: (value) => {
            let re = /(.)\1{2}/;
            return !re.test(value);
        },
        isCorrect: false
    },
    {
        text: "No debe contener más de dos caracteres consecutivos (p.e. 123, abc)",
        validator: (value) => {
            const seq1 = "abcdefghijklmnopqrstuvwxyz";
            const seq2 = "0123456789";
            const valLower = value.toLowerCase();
            for (let i = 0; i < valLower.length - 2; i++) {
                const chunk = valLower.substring(i, i + 3);
                if (seq1.includes(chunk) || seq2.includes(chunk)) {
                    return false;
                }
                const reverseChunk = chunk.split('').reverse().join('');
                if (seq1.includes(reverseChunk) || seq2.includes(reverseChunk)) {
                    return false;
                }
            }
            return true;
        },
        isCorrect: false
    },
    {
        text: "No debe contener espacios en blanco.",
        validator: (value) => {
            let re = /\s/;
            return !re.test(value);
        },
        isCorrect: false
    }
]

export function getPosicionCartera(cartera) {
    let ordenRama = {};
    let ordenFinal = {
        totalCartera: false,
        detalle: []
    };
    for (let ca of cartera) {
        //Ordenar por rama.
        let character = ca.Rama.trim().charAt(0);

        if (ordenRama[character]) {
            ordenRama[character].info.push(ca);
        } else {
            ordenRama[character] = {
                info: [ca]
            }
        }
    }

    //Ordena por niveles despues de ordenarRama
    let keys = Object.keys(ordenRama);

    for (let ks of keys) {
        let data = ordenRama[ks].info;

        for (let dt of data) {
            if (ordenRama[ks][dt.Nivel]) {
                ordenRama[ks][dt.Nivel].push(dt);
            } else {
                ordenRama[ks][dt.Nivel] = [dt];
            }
        }

        if (ordenRama[ks]['4'] && ordenRama[ks]['3']) {
            //Ordena el detalle del nivel 4 en el nivel 3
            let dataInfoLevelTres = ordenRama[ks]['3'];
            let dataInfoLevelCuatro = ordenRama[ks]['4'];

            for (let dit of dataInfoLevelTres) {
                //console.log(dit);
                let filter = dataInfoLevelCuatro.filter((v, i) => {
                    if (v.Rama === dit.Rama) {
                        return v;
                    }
                });
                dit.detalle = filter;
            }
            delete ordenRama[ks]['4'];

        }

        if (ordenRama[ks]['2'] && ordenRama[ks]['3']) {
            let dataInfoLvl2 = ordenRama[ks]['2'];
            let dataInfoLvl3 = ordenRama[ks]['3'];

            for (let dil2 of dataInfoLvl2) {
                let rama = dil2.Rama;
                dil2.detalle = [];
                for (let dil3 of dataInfoLvl3) {
                    if (dil3.Rama.includes(rama)) {
                        dil2.detalle.push(dil3);
                    }
                }
            }

            delete ordenRama[ks]['3']
        }

        if (ordenRama[ks]['1'] && ordenRama[ks]['2']) {
            let dataInfoLvl1 = ordenRama[ks]['1'];
            let dataInfoLvle2 = ordenRama[ks]['2'];

            for (let dil1 of dataInfoLvl1) {
                let rama = dil1.Rama;
                dil1.detalle = [];
                for (let dile2 of dataInfoLvle2) {
                    if (dile2.Rama.charAt(0).trim() === rama.trim()) {
                        dil1.detalle.push(dile2);
                    }
                }
            }

            delete ordenRama[ks]['2']
        }

        if (ordenRama[ks]['0']) {
            ordenFinal['totalCartera'] = ordenRama[ks]['0'];
        }

        if (ordenRama[ks]['1']) {
            ordenFinal['detalle'].push(ordenRama[ks]['1']);
        }

        delete ordenRama[ks]['info'];
    }

    //return ordenRama;
    return {
        ordenRama: ordenFinal,
        total: ordenFinal.totalCartera && ordenFinal.totalCartera.length ? `$${nWithCommas(parseFloat(ordenFinal.totalCartera[0].MontoMdoMN).toFixed(2).toString())}` : "",
        data: {
            labels: ['Saldo líquido',
                'Instrumentos de deuda y fondos de inversión de deuda',
                'Acciones y fondos de inversión de renta variable',
                'Instrumentos en otras divisas y fondos de inversión de deuda en otras divisas',
                'Derivados', 'Reportos Vigentes'],
            datasets: [
                {
                    data: [
                        30,
                        25,
                        15,
                        10,
                        10,
                        10
                    ],
                    backgroundColor: [
                        '#12C3E2',
                        '#6CDBC7',
                        '#A6D043',
                        '#A25EB5',
                        '#FFA400',
                        '#B7DDE1',
                    ]
                }
            ]
        }
    }
}

export async function getDivisas() {

    let objToReturn = []

    try {

        let resultDivisas = await makeCall(SERVICES.INFOCEL_DIVISAS, {});

        if (resultDivisas && resultDivisas.divisas) {
            objToReturn.push({
                name: "Divisas",
                d: resultDivisas.divisas.rows
            })
        }
    } catch (error) {

    }

    try {
        let resultMercancias = await makeCall(SERVICES.INFOCEL_MERCANCIAS, {});

        if (resultMercancias && resultMercancias.divisas) {
            objToReturn.push({
                name: "Mercancías",
                d: resultMercancias.divisas.rows
            })
        }
    } catch (error) {

    }


    try {

        let resultDeuda = await makeCall(SERVICES.INFOCEL_DEUDA, {});

        if (resultDeuda && resultDeuda.divisas) {
            objToReturn.push({
                name: "Deuda",
                d: resultDeuda.divisas.rows
            })
        }

    } catch (error) {

    }

    return objToReturn;
}

export async function getSaldoLiquido(props) {
    try {

        let bodySaldoLiquido = SERVICES.SALDO_LIQUIDO.body;
        bodySaldoLiquido.IdUsuario = encryptValues(props.dataUser ? props.dataUser.IdUsuario : "");
        bodySaldoLiquido.Contrato = encryptValues(props.currentContrato ? props.currentContrato.Contrato : "");
        bodySaldoLiquido.TipoSaldo = props.TipoSaldo;

        if (props.divisa) {
            bodySaldoLiquido.Divisa = props.divisa;
        }

        let resS = await makeCall(SERVICES.SALDO_LIQUIDO, bodySaldoLiquido);
        //
        if (resS && resS.response && resS.response.Exito === 200) {
            let saldos = resS.response['TTSALDOLIQUIDO']['TT-SALDOLIQUIDO'];


            let rs = {
                saldoLiquido: saldos
            }

            rs.totalSaldo = 0;
            rs.totalSaldoMXP = 0;
            for (let s of saldos) {
                if (s.Plazo === 0 && (s.Divisa === "MXP" || s.Divisa === "MXN")) {
                    rs.totalSaldoMXP += s.ImporteMXP;
                }

                //  if (s.Plazo === 0 && s.Divisa === "MXP") {
                if (s.Plazo === 0) {
                    rs.totalSaldo += s.ImporteMXP;
                }
            }

            return rs;
        }

        return 0;
    } catch (error) {

    }
}

export async function getIndices() {
    let objToReturn = []


    try {

        let resultIndices = await makeCall(SERVICES.INFOCEL_INDICES, {});

        if (resultIndices && resultIndices.divisas) {
            objToReturn = resultIndices.divisas.rows;
        }

    } catch (error) {
    }

    return objToReturn;

}

export async function getAcciones() {
    let objToReturn = [];

    try {

        let resultAcciones = await makeCall(SERVICES.INFOCEL_ACCIONES, {});

        if (resultAcciones && resultAcciones.divisas) {
            objToReturn = resultAcciones.divisas.rows;
        }
    } catch (error) {

    }

    return objToReturn;
}

export async function getCoordenadas(props) {

    if (navigator.geolocation) {

        const opciones = {
            enableHighAccuracy: true, // Pide al hardware la máxima precisión (ej. forzar uso de GPS)
            timeout: 10000,           // Tiempo máximo de espera (en milisegundos). Aquí son 10 segundos.
            maximumAge: 0             // Un valor de 0 obliga al navegador a buscar la ubicación actual y no usar una guardada en caché.
        }

        return await new Promise(async (resolve) => {
            navigator.geolocation.getCurrentPosition(async (showPosition) => {

                let { latitude, longitude } = showPosition.coords;

                try {
                    let estado = "";

                    let rs = await getDireccion(latitude, longitude);

                    props.setCoordenadas({ latitude, longitude, pais: rs.pais, ciudad: rs.ciudad, estado: rs.estado, direccion: rs.address })

                    resolve(true);

                } catch (error) {

                    props.okButton({
                        message: "No se logró obtener tu ubicación, lo cual es necesario por razones de seguridad y regulación para el uso de plataformas digitales. Revisa la configuración de tu navegador e intenta de nuevo.", title: "Advertencia", txtButton: "Entendido",
                        statusCode: 404
                    });

                    props.setCoordenadas(false);
                    resolve(false);
                }
            }, (error) => {
                props.okButton({
                    message: "Tu navegador no admite geolocalización, lo cual es necesario por razones de seguridad y regulación para el uso de plataformas digitales. Ajusta la configuración e intenta de nuevo.", title: "Advertencia", txtButton: "Entendido",
                    statusCode: 404
                });
                props.setCoordenadas(false);
                resolve(false);
            }, opciones);
        })
    } else {
        props.okButton({
            message: "Tu navegador no admite geolocalización, lo cual es necesario por razones de seguridad y regulación para el uso de plataformas digitales. Ajusta la configuración e intenta de nuevo.", title: "Advertencia", txtButton: "Entendido",
            statusCode: 404
        });
        props.setCoordenadas(false);
        return false;
    }
}

export async function getDireccion(lat, long) {

    try {
        let url = `${BASE_URL}/apigoogle/obtenerDireccion`;

        let res = await axios.post(url, { lat, long });
        if (res && res.data && res.data.length > 0) {


            let pais, ciudad, estado = "";

            if (res.data[0].address_components && res.data[0].address_components.length) {
                //Busca elementos para pais, ciiudad, estado

                for (let component of res.data[0].address_components) {
                    if (component.types && component.types.length) {
                        for (let type of component.types) {
                            if (type === 'administrative_area_level_1') {
                                estado = component.long_name;
                            }

                            if (type === 'country') {
                                pais = component.long_name;
                            }

                            if (type === 'locality') {
                                ciudad = component.long_name;
                            }
                        }
                    }
                }
            }

            let address = res.data[0].formatted_address;

            return {
                address,
                ciudad,
                estado,
                pais
            };
        } else {
            return "";
        }
    } catch (error) {

        return "";
    }
}

export async function setBitacora(data, email) {
    try {
        data.date = new Date();
        data.descripcion = 'Inicio de sesión web';
        data.plataforma = navigator.platform;
        let ref = await firebase.firestore().collection(`/usuarios/${email.trim().toLowerCase()}/bitacora`).add(data);
        //id del registro de esta sesión, se usa para detectar inicios de sesión en otro dispositivo
        sessionStorage.setItem('bitacoraId', ref.id);
    } catch (error) {

    }
}

export function encryptValues(value) {
    try {
        const ivLength = 16;
        let iv = window.config.APP_RIV;

        // Verificar si el IV tiene la longitud correcta
        if (iv.length !== ivLength) {
            iv = Crypto.randomBytes(ivLength);
        }

        let cipher = Crypto.createCipheriv('aes-256-cbc', window.config.APP_KCR_OBS, iv);
        let encrypt = cipher.update(value + '', 'utf-8', 'base64');
        encrypt += cipher.final('base64');
        return encrypt;
    } catch (error) {
        return value;
    }

}

export function decryptValue(value) {

    if (value === undefined || value === null || value.trim() === "") {
        return value;
    }

    try {

        const ivLength = 16;
        let iv = window.config.APP_RIV;

        // Verificar si el IV tiene la longitud correcta
        if (iv.length !== ivLength) {
            iv = Crypto.randomBytes(ivLength);
        }

        let decipher = Crypto.createDecipheriv('aes-256-cbc', window.config.APP_KCR_OBS, iv);
        //Si el '+' del base64 llegó convertido en espacio el descifrado falla
        var decrypted = decipher.update(`${value}`.replace(/ /g, '+'), 'base64', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    } catch (error) {
        console.log("Error al desecriptar")
        return value;
    }

}

export function decryptValueNot(value) {
    try {

        const ivLength = 16;
        let iv = window.config.APP_RIV;

        // Verificar si el IV tiene la longitud correcta
        if (iv.length !== ivLength) {
            iv = Crypto.randomBytes(ivLength);
        }

        let decipher = Crypto.createDecipheriv('aes-256-cbc', window.config.APP_KCR_OBS, iv);
        //Si el '+' del base64 llegó convertido en espacio el descifrado falla
        var decrypted = decipher.update(`${value}`.replace(/ /g, '+'), 'base64', 'utf8');
        decrypted += decipher.final('utf8');
        return decrypted;
    } catch (error) {
        return "";
    }

}

const servicesSet = new Set(LIST_SERVICES_DECRYPT);
const valuesToDecryptSet = new Set(LIST_TO_VALUES);


export function readObject(data, url) {

    if (!servicesSet.has(url)) return data;

    function recursiveDecrypt(obj) {
        // Si no es objeto o es null, retornar el valor tal cual
        if (!obj || typeof obj !== 'object') return obj;


        if (Array.isArray(obj)) {
            for (let i = 0; i < obj.length; i++) {
                obj[i] = recursiveDecrypt(obj[i]);
            }
            return obj;
        }

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                let val = obj[key];

                if (valuesToDecryptSet.has(key) && typeof val === 'string') {
                    obj[key] = decryptValue(val);
                }

                if (val && typeof val === 'object') {
                    obj[key] = recursiveDecrypt(val);
                }
            }
        }
        return obj;
    }

    try {
        return recursiveDecrypt(data);
    } catch (error) {
        console.error("Error en la desencriptación:", error);
        return data;
    }
}

export async function getData_menuExterior() {
    try {
        let snap = await firebase.firestore().doc(`/configuraciones/pantallas`).get();
       
        let configLumina = await getConfigLuminaEndPoint();

        if (snap.exists) {

            let data = snap.data();
            // configLumina ya no existe en Firestore; la bandera sale de /endpoint/lumina
            data['configLumina'] = { ...(data['configLumina'] || {}), activo: configLumina };

            return data;
        }
        return false;


    } catch (error) {
        return false;
    }
}

/**
 * Obtiene la configuración del pop-up de login (configuraciones/popup_login).
 * Regresa la configuración solo si está activa, dentro de vigencia y aplica
 * a la plataforma actual (lumina / tas), en otro caso regresa false.
 */
export async function getConfigPopupLogin() {
    try {
        let snap = await firebase.firestore().doc(`/configuraciones/popup_login`).get();

        if (!snap.exists) {
            return false;
        }

        let config = snap.data();

        if (!config.activo || !config.imagen_url || !config.fecha_inicio || !config.fecha_fin) {
            return false;
        }

        let ahora = new Date();
        if (ahora < config.fecha_inicio.toDate() || ahora > config.fecha_fin.toDate()) {
            return false;
        }

        let plataforma = (config.plataforma || 'ambas').trim().toLowerCase();
        if (plataforma !== 'ambas') {
            let plataformaActual = await getConfigLuminaEndPoint() ? 'lumina' : 'tas';
            if (plataforma !== plataformaActual) {
                return false;
            }
        }

        return config;

    } catch (error) {
        return false;
    }
}

export function mostrarPopupLogin() {
    window.dispatchEvent(new Event('mostrarPopupLogin'));
}

async function getConfigLuminaEndPoint() {
    try {

        let snap = await firebase.firestore().doc(`/endpoint/lumina`).get();

        if (snap.exists) {
            return snap.data().bandera || false;
        }

        return false;

    } catch (error) {
        return false;
    }
}


export async function getMenuOperaciones() {
    try {
        let snap = await firebase.firestore().collection(`/configuraciones/menus/operaciones`).get();

        if (snap.docs.length) {

            return snap.docs.map((v, i) => {
                return { id: v.id, ...v.data() };
            })

        }
        return false;


    } catch (error) {
        return false;
    }
}

export async function getLuminaSetting() {
    try {
        let snap = await firebase.firestore().doc(`/endpoint/lumina`).get();

        if (snap.exists) {

            return snap.data();
        }
        return false;


    } catch (error) {
        return false;
    }
}

export async function getConfiguracionCR() {
    try {
        let snap = await firebase.firestore().doc(`/configuraciones/variables`).get();

        if (snap.exists) {

            return snap.data();
        }
        return false;


    } catch (error) {
        return false;
    }
}


export async function getDeviceToken(uid) {
    if (uid) {
        try {
            let sna = await firebase.firestore().doc(`/usuarios/${uid}/configuraciones/token`).get();
            if (sna.exists) {

                let dataUserConfig = sna.data();
                if (dataUserConfig.device_token) {
                    return dataUserConfig.device_token;
                }
                return "";
            }
            return "";
        } catch (error) {
            return "";
        }
    }
    return "";
}

export async function getTipoServicios({ dataUser, currentContrato }, props) {
    let servicios = [];
    try {

        let tipoServiciosBody = SERVICES.TIPO_SERVICIO.body;
        tipoServiciosBody.IdUsuario = encryptValues(dataUser.IdUsuario);
        tipoServiciosBody.Contrato = encryptValues(currentContrato.Contrato);

        let resultTipoServicio = await makeCall(SERVICES.TIPO_SERVICIO, tipoServiciosBody);

        if (resultTipoServicio && resultTipoServicio.response && resultTipoServicio.response.Exito === 200) {
            let ttser = resultTipoServicio.response['TTSERVINVER']['TT-SERVINVER'];

            let filtro = ttser.filter((v, i) => {
                if (v.Contrato === currentContrato.Contrato) {

                    props.setTiposServiciosOpera(v.Servicio);
                    return v;
                }
            });

            if (ttser.length) {
                //va por los datos de firebase;
                let docsServicios = await firebase.firestore().collection('configuraciones/inversion/servicios').get();
                if (docsServicios.docs.length) {
                    for (let docS of docsServicios.docs) {
                        let dataDocs = docS.data();
                        dataDocs.NoEsUsuario = true;
                        if (dataDocs.habilitado) {
                            for (let f of filtro) {
                                if (dataDocs.id === f.Servicio) {
                                    dataDocs.NoEsUsuario = false;
                                }
                            }
                            servicios.push(dataDocs);
                        }
                    }
                }
            }
        }

        return servicios;

    } catch (error) {
        return servicios;
    }
}


const ID_BLOQUEO_CIERRE_SESION = 'bloqueoCierreSesion';

//Bloquea la UI mientras se cierra la sesión para que no se puedan abrir modales en ese intervalo.
export function bloquearUICierreSesion() {
    try {
        if (document.getElementById(ID_BLOQUEO_CIERRE_SESION)) {
            return;
        }
        let bloqueo = document.createElement('div');
        bloqueo.id = ID_BLOQUEO_CIERRE_SESION;
        bloqueo.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;background:transparent;';
        document.body.appendChild(bloqueo);
    } catch (error) {

    }
}

export function desbloquearUICierreSesion() {
    try {
        let bloqueo = document.getElementById(ID_BLOQUEO_CIERRE_SESION);
        if (bloqueo) {
            bloqueo.remove();
        }
    } catch (error) {

    }
}

//Cierra todos los modales sin depender de la animación de Materialize (que no termina con la pestaña en segundo plano).
export function cerrarTodosLosModales(excepto = []) {
    let modals = document.querySelectorAll('.modal');

    for (let modal of modals) {
        if (excepto.some((clase) => modal.classList.contains(clase) || modal.id === clase)) {
            continue;
        }

        try {
            let instance = M.Modal.getInstance(modal);
            if (instance && instance.isOpen) {
                instance.close();
            }
        } catch (error) {

        }

        modal.classList.remove('open');
        modal.style.display = 'none';
    }

    //Overlays de los modales que se cerraron; los de los modales exceptuados que siguen abiertos se conservan.
    for (let overlay of document.querySelectorAll('.modal-overlay')) {
        let modalPrevio = overlay.previousElementSibling;
        if (!modalPrevio || !modalPrevio.classList.contains('open')) {
            overlay.remove();
        }
    }

    if (!document.querySelector('.modal.open')) {
        document.body.style.overflow = '';
    }
}

export function deleteSesion(id_usuario, props, action) {

    props = props || {};

    bloquearUICierreSesion();

    try {
        firebase.auth().signOut().then(() => {

            if (window.suscribes) {
                for (let su of window.suscribes) {
                    su();
                }
            }

            if (window.unsubscribe) {
                window.unsubscribe();
            }
        }).catch((er) => {

        });
    } catch (error) {

    } finally {

        try {
            let instance = M.Sidenav.getInstance(document.querySelectorAll('.sidenavUser')[0]);
            if (instance) {
                instance.close();
                instance.destroy();
            }
        } catch (error) {

        }

        try {
            let instanceMenu = M.Sidenav.getInstance(document.querySelectorAll('.sidenav')[0]);

            if (instanceMenu) {
                instanceMenu.close();
                instanceMenu.destroy();
            }
        } catch (error) {

        }

        cerrarTodosLosModales();


        let bodyCerrarSesion = SERVICES.TERMINA_SESION.body;
        bodyCerrarSesion.idUsuario = encryptValues(id_usuario.toLowerCase());

        makeCall(SERVICES.TERMINA_SESION, bodyCerrarSesion).catch(() => {

        }).then(() => {
            localStorage.removeItem('dataUser');
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('authorization');
            localStorage.removeItem('idToken');
            sessionStorage.removeItem('bitacoraId');

            if (typeof props.setDataUser === "function") {
                props.setDataUser(false);
            }

            if (typeof props.setContratos === "function") {
                props.setContratos(false);
            }

            if (typeof props.setCurrentContrato === "function") {
                props.setCurrentContrato(false);
            }

            if (typeof props.setChequera === "function") {
                props.setChequera(false);
            }

            //Cierra los modales que se hayan abierto mientras respondía TERMINA_SESION.
            //Se conserva el aviso de fin de sesión.
            cerrarTodosLosModales(['modal_okButton', 'modalInfo']);

            if (action) {
                action();
            }

        }).finally(() => {
            desbloquearUICierreSesion();
        });

        if (window.unsubscribe) {
            window.unsubscribe();
        }

    }

    try {

        let instanceMenuNo = M.Sidenav.getInstance(document.querySelectorAll('.sidenavNoSesion')[0]);

        if (instanceMenuNo) {
            instanceMenuNo.close();
            instanceMenuNo.destroy();
        }

    } catch (error) {

    }
}

export function addSuscribe(sub) {
    if (window.suscribes) {
        window.suscribes.push(sub);
    } else {
        window.suscribes = [sub];
    }
}

export async function getRendimientos({ dataUser, currentContrato }) {
    try {

        let bodyRendimientos = SERVICES.RENDIMIENTOS.body;
        bodyRendimientos.IdUsuario = encryptValues(dataUser.IdUsuario);
        bodyRendimientos.Contrato = encryptValues(currentContrato ? currentContrato.Contrato : "");

        const resultRendimientos = await makeCall(SERVICES.RENDIMIENTOS, bodyRendimientos);

        if (resultRendimientos && resultRendimientos.response && resultRendimientos.response.Exito === 200) {
            return resultRendimientos.response;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }

}

export function openTip() {
    let instance = M.Modal.getInstance(document.querySelectorAll('.modalRecarga')[0]);
    if (instance) {
        instance.open();
    }
}


export function closeTip() {
    let instance = M.Modal.getInstance(document.querySelectorAll('.modalRecarga')[0]);
    if (instance) {
        instance.close();
    }
}


export async function getCuentaBancaria(contrato) {
    try {
        let bodyCuentaBancaria = SERVICES.CUENTA_BANCARIA.body;
        bodyCuentaBancaria.contrato = contrato
        let resultCuentaBancaria = await makeCall(SERVICES.CUENTA_BANCARIA, bodyCuentaBancaria);

        return resultCuentaBancaria.clabeInterbancaria;

    } catch (error) {

        return "";
    }
}

export async function toReload({ dataUser, props }, contrato) {

    //obtiene la instancia del modal para recarga.
    let instance = M.Modal.getInstance(document.querySelectorAll('.modalRecarga')[0]);

    if (instance) {
        instance.open();
    } else {

        var instances = M.Modal.init(document.querySelectorAll('.modalRecarga'), {
            dismissible: false,
        });
        if (instances.length) {
            instance = instances[0];
            instance.open();
        }

    }

    // Permitimos que el navegador respire y logre arrancar la animación y renderizar el Modal
    await new Promise(resolve => setTimeout(resolve, 300));

    try {

        let ultimoContrato = await getContratosF(dataUser.IdUsuario);
        let service = SERVICES.CONTRATOS;
        let body = service.body;
        body.IdUsuario = encryptValues(dataUser.IdUsuario);
        body.DeviceToken = dataUser.deviceToken;

        //Consulta primera vez los contratos con randmon
        const codigo = Math.floor(100000 + Math.random() * 900000);
        body.contrato = codigo;
        let contratoToSet = null;

        try {
            //Obtiene los contratos de forma temporal para poder asignar el que viene por defecto en el listado de contratos
            let resultContratosTemp = await makeCall(service, body);

            const listaContratos = resultContratosTemp.response.TTCONTRATOS["TT-CONTRATOS"];

            if (listaContratos.length) {
                //Colo por defecto el primer contrato
                contratoToSet = listaContratos[0];

                if (ultimoContrato) {
                    for (let con of listaContratos) {
                        if (ultimoContrato.currentContrato === con.Contrato) {
                            contratoToSet = con;
                            break;
                        }
                    }
                }

                await setContratoF(contratoToSet.Contrato, dataUser.IdUsuario);
            }

        } catch (e) {

        }

        body.contrato = contratoToSet.Contrato;

        let resultContratos = await makeCall(service, body);

        props.setContratos(resultContratos.response);

        sessionStorage.setItem('hash', resultContratos.response.hash);

        contratoToSet.clabeInterbancaria = await getCuentaBancaria(contratoToSet.Contrato);

        props.setCurrentContrato(contratoToSet);

        contrato = contratoToSet

        props.setDataUser(dataUser);
        let serviceChequera = SERVICES.CHEQUERA;
        let bodyChequera = serviceChequera.body;
        bodyChequera.IdUsuario = encryptValues(dataUser.IdUsuario);
        bodyChequera.DeviceToken = dataUser.deviceToken;

        let chequera = await makeCall(serviceChequera, bodyChequera);
        props.setChequera(chequera.response.TTCUENTAS['TT-CUENTAS']);

        await new Promise(resolve => setTimeout(resolve, 50));

        let saldoTotal = await getSaldoLiquido({
            dataUser,
            currentContrato: contrato,
            TipoSaldo: "P"
        });


        if (saldoTotal) {
            props.setSaldoTotal(saldoTotal.totalSaldo);
            props.setSaldoLiquido(saldoTotal.saldoLiquido);
        } else {
            props.setSaldoTotal(0);
        }

        await new Promise(resolve => setTimeout(resolve, 50));

        const rendimientos = await getRendimientos({
            dataUser,
            currentContrato: contrato
        });

        props.setRendimientos(rendimientos);

        await new Promise(resolve => setTimeout(resolve, 50));

        const servicios = await getTipoServicios(
            {
                dataUser,
                currentContrato: contrato
            },
            props
        );

        props.setTiposServicios(servicios);

        await new Promise(resolve => setTimeout(resolve, 50));

        let bodyPosicion = SERVICES.POSICION_CARTERA.body;
        bodyPosicion.IdUsuario = encryptValues(dataUser.IdUsuario);
        bodyPosicion.Contrato = encryptValues(contrato.Contrato);


        let resultCartera = await makeCall(SERVICES.POSICION_CARTERA, bodyPosicion);

        // Permitimos que la UI se recupere del posible bloqueo por la desencriptación del payload
        await new Promise(resolve => setTimeout(resolve, 50));

        if (resultCartera && resultCartera.response) {
            props.setPosicionCartera(resultCartera.response);
        }

        // Damos un último respiro para que React termine el ciclo de renderizado provocado por setPosicionCartera
        // antes de decirle al modal que inicie su animación de cierre.
        await new Promise(resolve => setTimeout(resolve, 150));

        instance.close();

    } catch (error) {
        instance.close();
    }

}


export function getComision(fondo, monto) {

    if (fondo.Comision) {
        return parseFloat(monto / 100 * fondo.Comision);
    }

    return 0;
}

export function getIva(fondo, monto) {
    if (fondo.IVAComision) {
        return roundDouble(parseFloat(monto / 100 * fondo.IVAComision), 2);
    }

    return 0;
}

export function roundDouble(value, places) {
    let mod = Math.pow(10.0, places);
    return (Math.round(value * mod) / mod);
}

export async function getDownloadUrl(path) {
    try {

        const urlTapiz = await firebase.storage().ref(path).getDownloadURL();
        return urlTapiz;

    } catch (error) {
        return false;
    }
}


export async function shareDetail(id) {
    const input = document.getElementById(id);
    const details = document.getElementsByClassName('detailCard');
    const cabeceraComprobante = document.getElementById('cabeceraComprobante');
    // Capturamos únicamente el contenedor global de los pies de página
    const footerBloqueCompleto = document.getElementById('footerBloqueCompleto');

    if (details.length) {
        const doc = new jsPDF('p', 'px', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        for (let i = 0; i < details.length; i++) {
            let d = details[i];
            let canvas = await html2canvas(d, {
                scrollY: -window.scrollY,
                scrollX: -window.scrollX,
                scale: 2,
                useCORS: true,
                y: -11,
                x: -100,
                width: d.clientWidth + 500,
                height: d.clientHeight + 100
            });

            var margin = 2;
            var position = 10;

            if (i === 0) {
                let canvasCabecera = await html2canvas(cabeceraComprobante, {
                    scrollY: -window.scrollY,
                    scrollX: -window.scrollX,
                    scale: 2,
                    useCORS: true,
                    y: -11,
                    x: -100,
                    width: cabeceraComprobante.clientWidth + 500,
                    height: cabeceraComprobante.clientHeight + 100
                });

                const canvasCabeceraDataUrl = canvasCabecera.toDataURL('image/jpeg', 0.82);
                const { marginX, canvasWidth, canvasHeight } = getCanvasSizes(canvasCabecera, pageWidth, pageHeight);
                doc.addImage(canvasCabeceraDataUrl, 'JPEG', marginX, 0, canvasWidth + (pageWidth - (75 * pageWidth / 100)), canvasHeight + (15 * canvasHeight / 100));

                position = canvasHeight + 5;
            }

            const contentDataURL = canvas.toDataURL('image/jpeg', 0.82);

            if (i > 0) {
                doc.addPage();
            }

            const { marginX, canvasWidth, canvasHeight } = getCanvasSizes(canvas, pageWidth, pageHeight);
            doc.addImage(contentDataURL, 'JPEG', marginX, position, canvasWidth + (pageWidth - (75 * pageWidth / 100)), canvasHeight + (15 * canvasHeight / 100));

            doc.setFontSize(9);

            // --- BLOQUE DE FOOTERS REESTRUCTURADO (Última Página) ---
            if (i === details.length - 1 && footerBloqueCompleto) {

                // Usamos la misma configuración que utilizas para el elemento principal ('d')
                let footerCanvas = await html2canvas(footerBloqueCompleto, {
                    scrollY: -window.scrollY,
                    scrollX: -window.scrollX,
                    scale: 2,
                    useCORS: true,
                    y: -11,
                    x: -100,
                    width: footerBloqueCompleto.clientWidth + 500,
                    height: footerBloqueCompleto.clientHeight + 100
                });

                const footerCanvasDataUrl = footerCanvas.toDataURL('image/jpeg', 0.82);

                let my = canvasHeight;
                if (details.length === 1) {
                    my += 40;
                }

                const rsFC = getCanvasSizes(footerCanvas, pageWidth, pageHeight);

                // Se añade con la misma fórmula exacta de dimensiones que tus tarjetas para que no se desfase
                doc.addImage(footerCanvasDataUrl, 'JPEG', marginX, my, rsFC.canvasWidth + (pageWidth - (75 * pageWidth / 100)), rsFC.canvasHeight + 10);
            }
            // --------------------------------------------------------

            doc.setFontSize(9);
            doc.text('Página ' + String(i + 1) + ' de ' + String(details.length), pageWidth - 83, pageHeight - 30, null, null, "right");
        }

        doc.save('Comprobante.pdf');
    }
}

function getCanvasSizes(canvas, pageWidth, pageHeight) {

    const widthRatio = pageWidth / canvas.width;
    const heightRatio = pageHeight / canvas.height;
    const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

    const canvasWidth = canvas.width * ratio;
    const canvasHeight = canvas.height * ratio;

    const marginX = (5 * pageWidth / 100);
    const marginY = (pageHeight - canvasHeight) / 2;

    return {
        canvasWidth, canvasHeight, marginX, marginY
    }
}

export function getInfo(obj) {

    const keys = Object.keys(obj);

    for (let k of keys) {
        if (obj[k].trim() != "") {
            // console.log("==========================")
            // console.log("PROPIEDAD ", k)
            // console.log("VALOR " , obj[k]);
            // console.log("__________________________")
            // console.log("VALOR DESENCRIPTADO");

            try {
                // console.log(decryptValue(obj[k]));
            } catch (error) {
                // console.log("No logro desencriptar " , k)
            }
            // console.log("==========================")
        }
    }
}

export async function setContratoF(currentContrato, email) {
    try {
        await firebase.firestore()
            .doc(`/usuarios/${email}/contrato/actual`)
            .set({ currentContrato }); // ya no lo envuelvas en { currentContrato }

        return true;
    } catch (error) {
        console.error("Error al guardar el contrato:", error);
        return false;
    }
}

export async function getContratosF(email) {
    try {
        const doc = await firebase.firestore()
            .doc(`/usuarios/${email}/contrato/actual`)
            .get();

        if (doc.exists) {
            return { id: doc.id, ...doc.data() };
        } else {
            return null; // no hay contrato aún
        }
    } catch (error) {
        console.error("Error al obtener el contrato:", error);
        return null;
    }
}

export function base64toBlob(data) {
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: 'application/pdf' });
};



export async function getConfigWriter(passZip) {

    try {
        let snap = await firebase.firestore().doc(`/configuraciones/pantallas`).get();

        if (snap.exists) {

            const dataPantallas = snap.data();

            if (dataPantallas.documentos.show) {
                return new window.zip.ZipWriter(
                    new window.zip.BlobWriter("application/zip"),
                    {
                        password: passZip,
                        encryptionStrength: 3, // AES-256
                    }
                );
            }
        }

        return new window.zip.ZipWriter(
            new window.zip.BlobWriter("application/zip")
        );


    } catch (error) {
        return new window.zip.ZipWriter(
            new window.zip.BlobWriter("application/zip")
        );
    }
}


export function corregirPrecio(precio) {
    let precioCorregido = "";

    if (precio) {
        precioCorregido = precio.startsWith('.') ? '$ 0' + precio : '$ ' + precio;
    }

    return precioCorregido;
}

export async function getOrdenesPendientes(contrato) {

    try {

        const serviceToCall = {
            "url": `opera/ordenesPendientes`,
            "method": "POST",
            "body": {
                contrato: encryptValues(contrato)
            },
            "noParams": true
        }

        let resultOrdenes = await makeCall(serviceToCall, { contrato: encryptValues(contrato) });

        if (!resultOrdenes) {
            return null;
        }
        const operaciones = resultOrdenes.response
            && resultOrdenes.response.TTOPERACIONES
            && resultOrdenes.response.TTOPERACIONES['TT-OPERACIONES'];

        if (!operaciones || !operaciones.length) {
            return null;
        }

        return agruparPorTipoOper(operaciones);

    } catch (error) {
        console.log("Error al obtener ordenes pendientes: ", error);

        return null;
    }

}

function agruparPorTipoOper(arr) {
    return arr.reduce((acumulador, item) => {
        const tipo = item.TipoOper || "Sin tipo"; // por si viene vacío
        if (!acumulador[tipo]) {
            acumulador[tipo] = [];
        }
        acumulador[tipo].push(item);
        return acumulador;
    }, {});
}


export async function obtenerFondo(nombreFondo) {
    try {
        const docRef = firebase.firestore().doc(`/configuracionFondosActivos/${nombreFondo}`);
        const docSnap = await docRef.get();

        if (docSnap.exists) {
            return docSnap.data();
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error al obtener el fondo:", error);
        throw error;
    }
}

//configuracionFondosActivos

export async function setConfigFondosActivos() {
    try {
        const db = firebase.firestore();

        const data = {
            "VXREPO1": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2F1"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Pasiva",
                "HApertura": "8:00",
                "HCierre": "14:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo radica en ser una alternativa de inversión con el menor riesgo posible y con liquidez inmediata."
            },
            "VXGUBCP": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2F1",
                    "B2NC",
                    "B4FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El fondo tiene como objetivo ofrecer una alternativa de inversión de corto plazo (menores a 1 año), con el menor riesgo posible y con liquidez diaria."
            },
            "VXGUBLP": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2F1",
                    "B2NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El fondo tiene como objetivo ofrecer una alternativa de inversión de largo plazo. Como base de referencia el fondo utiliza un índice cuyas inversiones oscilan entre 3 y 10 años con valores gubernamentales."
            },
            "VXDEUDA": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2F1",
                    "B2NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es invertir en plazos donde nuestras estimaciones muestren utilidad respecto a la curva de mercado en pesos a tasa nominal y a tasa real, mediante la inversión."
            },
            "VXUDIMP": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2CF",
                    "B2CO",
                    "B2F1",
                    "B2NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El fondo tiene como objetivo ofrecer una alternativa de inversión que esté referenciada a la inflación."
            },
            "VALMXRP": {
                "series": [
                    "A"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El fondo tiene como objetivo ofrecer una alternativa de inversión que esté referenciada a la inflación."
            },
            "VALMX11": {
                "series": [
                    "A"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "BX+0": {
                "series": [
                    "A",
                    "B-E1",
                    "B-E2",
                    "B-E3",
                    "B-F1",
                    "B-F2",
                    "B-F3",
                    "B-M1",
                    "B-M2",
                    "B-M3",
                    "X1"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "9:00",
                "HCierre": "14:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El objetivo es invertir en valores gubernamentales, bancarios y corporativos, a tasa fija y variable, así como en Instrumentos emitidos en UDIS, en moneda extranjera (dólares)."
            },
            "BX+1": {
                "series": [
                    "A",
                    "B-E1",
                    "B-E2",
                    "B-E3",
                    "B-F1",
                    "B-F2",
                    "B-F3",
                    "B-M1",
                    "B-M2",
                    "B-M3",
                    "X1"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "9:00",
                "HCierre": "14:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El objetivo es invertir en valores de deuda que ofrecen tasa nominal en pesos y/o UDIS, en moneda extranjera. De manera directa invierte en valores  gubernamentales, bancarios y corporativos, nacionales o extranjeros, denominados en pesos, UDIS o dólares."
            },
            "VXCOBER": {
                "series": [
                    "A",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1C0",
                    "B1FI",
                    "B1NC",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es ofrecer una alternativa de cobertura cambiaria respecto al dólar americano."
            },
            "VXTBILL": {
                "series": [
                    "A",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:00",
                "HCierre": "12:45",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El objetivo del fondo es invertir los recursos captados del público inversionista en valores de Deuda denominados en dólares americanos."
            },
            "VALMX19": {
                "series": [
                    "A",
                    "B"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "8:30",
                "HCierre": "14:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El objetivo del fondo es invertir los recursos provenientes de sus inversionistas en Activos Objeto de Inversión de Renta Variable."
            },
            "VALMX20": {
                "series": [
                    "A",
                    "B0",
                    "B1"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "9:30",
                "HCierre": "14:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "El fondo tiene como objetivo ofrecer al público inversionista una alternativa de inversión cuya estrategia busque superar el rendimiento del S&P/BMV Índice de Precios."
            },
            "VALMX28": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CO",
                    "B1FI",
                    "B1NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es invertir los recursos captados del público inversionista en Acciones y mecanismos de inversión colectiva, denominados ETF´s (Exchange Traded Funds)."
            },
            "VALMXA": {
                "series": [
                    "A",
                    "B0",
                    "B1",
                    "B2"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es ofrecer al público inversionista, rendimientos en el largo plazo, con base en un modelo de asignación óptima de recursos."
            },
            "VALMXLPE": {
                "series": [
                    "A",
                    "B0NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "8:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es ofrecer al público inversionista, rendimientos en el largo plazo, con base en un modelo de asignación óptima de recursos."
            },
            "VALMXETF": {
                "series": [
                    "A",
                    "B0FI",
                    "B1CO",
                    "B1FI",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "10:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Es un fondo cuyo objetivo es invertir en acciones, mecanismos de inversión colectiva, denominados ETF´s (Exchange Traded Funds) y/o Trackers."
            },
            "VALMXVL": {
                "series": [
                    "A",
                    "B0",
                    "B1",
                    "B2",
                    "B3"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "VALMXES": {
                "series": [
                    "A",
                    "B0",
                    "B1",
                    "B2",
                    "B3"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "8:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "VLMXTEC": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "VLMXESG": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "BX+2": {
                "series": [
                    "A",
                    "B-E1",
                    "B-E3",
                    "B-F1",
                    "B-F2"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "BX+3": {
                "series": [
                    "A",
                    "B-E1",
                    "B-E2",
                    "B-F2"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:30",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "VALMXHC": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": ""
            },
            "VALMXDME": {
                "series": [
                    "A",
                    "B0CF",
                    "B0CO",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1FI",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Estrategia discrecional en deuda denominada principalmente en dólares americanos."
            },
            "VXINFRA": {
                "series": [
                    "A",
                    "B0CO",
                    "B0FI",
                    "B1FI",
                    "B2FI"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "13:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Enfoque hacia el sector de infraestructura sustentable."
            },
            "VLMXJUB": {
                "series": [
                    "A",
                    "B0CF",
                    "B0NC",
                    "B1CF",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que hoy disfrutan de su pensión."
            },
            "VLMXP24": {
                "series": [
                    "A",
                    "B0CF",
                    "B0NC",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2024 iniciarán su etapa de retiro."
            },
            "VLMXP31": {
                "series": [
                    "A",
                    "B0CF",
                    "B0FI",
                    "B0NC",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2031 iniciarán su etapa de retiro."
            },
            "VLMXP38": {
                "series": [
                    "A",
                    "B0CF",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2038 iniciarán su etapa de retiro."
            },
            "VLMXP45": {
                "series": [
                    "A",
                    "B0CF",
                    "B0FI",
                    "B0NC",
                    "B1CF",
                    "B1CO",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2045 iniciarán su etapa de retiro."
            },
            "VLMXP52": {
                "series": [
                    "A",
                    "B0FI",
                    "B0NC",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2052 iniciarán su etapa de retiro."
            },
            "VLMXP59": {
                "series": [
                    "A",
                    "B0NC",
                    "B1FI",
                    "B1NC",
                    "B2NC",
                    "B3NC"
                ],
                "liquidez": "Diario / Mismo día",
                "Plazo": "Largo Plazo",
                "TipoGestion": "Activa",
                "HApertura": "7:30",
                "HCierre": "12:00",
                "FondoAbierto": true,
                "CpaAbierta": true,
                "VtaAbierta": true,
                "Descripcion": "Para aquellas personas que en el año 2059 iniciarán su etapa de retiro."
            }
        };

        for (const [fondoId, fondoData] of Object.entries(data)) {
            try {
                await db.collection("configuracionFondosActivos")
                    .doc(fondoId)
                    .set(fondoData);

                console.log(`✅ Fondo ${fondoId} guardado correctamente`);
            } catch (error) {
                console.error(`❌ Error al guardar el fondo ${fondoId}:`, error);
            }
        }

        console.log("Fondos guardados correctamente en Firestore ✅");
    } catch (error) {
        console.error("Error al guardar la configuración de fondos activos:", error);
    }
}


export const cleanHorario = (horario) => {
    if (horario.endsWith(":00")) {
        horario = horario.substring(0, horario.length - 3);
    }

    return horario;
}